import { IonButton } from "@ionic/react";

interface Props {
  setReturnToStart: Function;
}
const ReturnToStartModal: React.FC<Props> = ({ setReturnToStart }) => {
  return (
    <>
      <div className="person-detected-modal text-center flex-column">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="240"
          height="344"
          viewBox="0 0 240 344"
          fill="none"
        >
          <rect
            opacity="0.4"
            y="282.548"
            width="240"
            height="61"
            fill="#890029"
          />
          <path
            d="M150.296 30.5479C150.296 47.1166 136.729 60.5479 120.008 60.5479C103.287 60.5479 89.7204 47.1166 89.7204 30.5479C89.7204 13.9791 103.287 0.547852 120.008 0.547852C136.729 0.547852 150.296 13.9791 150.296 30.5479ZM114.96 220.548V300.548C114.96 311.61 105.937 320.548 94.7683 320.548C83.5998 320.548 74.5766 311.61 74.5766 300.548V161.11L56.5492 190.86C50.8071 200.298 38.4018 203.36 28.8423 197.673C19.2825 191.985 16.1903 179.735 21.9348 170.235L58.7071 109.673C69.6549 91.6104 89.3418 80.5479 110.606 80.5479H129.41C150.674 80.5479 170.361 91.6104 181.34 109.673L218.064 170.235C223.806 179.735 220.714 191.985 211.186 197.673C201.595 203.36 189.228 200.298 183.486 190.86L165.439 161.11V300.548C165.439 311.61 156.416 320.548 145.248 320.548C134.079 320.548 125.056 311.61 125.056 300.548V220.548H114.96Z"
            fill="#802392"
          />
        </svg>
        {/* <div
          style={{
            zIndex: "-1",
            position: "absolute",
            top: "267px",
            width: "101px",
            height: "35px",
            backgroundColor: "#D9131375",
          }}
        ></div> */}
        <div
          style={{
            paddingTop: "32px",
            display: "flex",
            flexDirection: "column",
          }}
          className="fz-30 fw-700 text-center lh-normal mb-0 align-center"
        >
          <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
            Please Return to
          </h1>
          <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
            the Starting Area
          </h1>
        </div>
      </div>
    </>
  );
};
export default ReturnToStartModal;
